import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["alt", "src"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "m19.5 8.25-7.5 7.5-7.5-7.5"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.prompt_lang_select && $setup.prompt_lang_select(...args))),
    class: "lang-select"
  }, [
    _createElementVNode("img", {
      alt: $setup.config.lang.country,
      src: `https://hatscripts.github.io/circle-flags/flags/${$setup.config.lang.country}.svg`,
      width: "24",
      class: "flag"
    }, null, 8, _hoisted_1),
    _createElementVNode("span", null, _toDisplayString($setup.languages[$setup.config.lang.iso]), 1),
    _hoisted_2
  ]))
}